module.exports = __webpack_public_path__ + "img/Logo_CMYK.a9027c81.jpg";